import configJson from "../../appsettings.json";
import packageJson from "../../package.json";

export function getAudience() {
  const audience =
    configJson.Auth0.Audience &&
    configJson.Auth0.Audience !== "YOUR_API_IDENTIFIER"
      ? configJson.Auth0.Audience
      : null;
  return audience ? { audience } : null;
}

export function getConfig() {
  // Configure the audience here. By default, it will take whatever is in the config
  // (specified by the `audience` key) unless it's the default value of "YOUR_API_IDENTIFIER" (which
  // is what you get sometimes by using the Auth0 sample download tool from the quickstart page, if you
  // don't have an API).
  // If this resolves to `null`, the API page changes to show some helpful info about what to do
  // with the audience.
  const audience = getAudience()?.audience;

  return {
    domain: configJson.Auth0.Domain,
    clientId: configJson.Auth0.ClientId,
    baseUrl: configJson.BaseUrl,
    ...(audience ? { audience } : null),
    bannerUrl: configJson.BannerUrl,
    megaPipeTradesUrl: configJson.MegaPipe.BaseUrl + "/tradehub",
    megaPipePricesUrl: configJson.MegaPipe.BaseUrl + "/pricehub",
    megaPipeBlocksUrl: configJson.MegaPipe.BaseUrl + "/blockhub",
    megaPipeAxesUrl: configJson.MegaPipe.BaseUrl + "/axehub",
    version: packageJson.version,
  };
}
